import ReactOnRails from "react-on-rails-pro"

import { withClientProviders } from "bundles/startup/common/withClientProviders"
import { withClientRenderer } from "bundles/startup/common/withClientRenderer"
import JewlrApp from "jewlr/main"

ReactOnRails.register({
  JewlrApp: withClientRenderer(withClientProviders(JewlrApp)),
})
